import { formatDateTime } from "../utils/formatDate";

interface PublishedTimestampProps {
  readonly publishedAt: string | null;
  readonly draftedAt?: string | null;
}

export function PublishedTimestamp({ publishedAt, draftedAt }: PublishedTimestampProps) {
  return (
    <div className="mt-6 text-sm text-text-tertiary">
      {draftedAt ? <div>Draft saved {formatDateTime(draftedAt)}</div> : null}
      <div>Published {publishedAt ? formatDateTime(publishedAt) : ""}</div>
    </div>
  );
}
